module.exports = __webpack_public_path__ + "img/黄色背景图2.68e1be8d.jpg";